export const HELP_ORIGIN = 'https://help.openlearning.com';

export const INSTITUTION_EMAIL_CONSENT =
  'https://help.openlearning.com/t/g9h673l';

export const SOLUTIONS_ORIGIN = 'https://solutions.openlearning.com';

export const TOS_GENERAL_URL = `${SOLUTIONS_ORIGIN}/terms-of-service/`;

export const TOS_IOS_URL = `${SOLUTIONS_ORIGIN}/terms-of-service-ios/`;

export const PRIVACY_POLICY_URL = `${SOLUTIONS_ORIGIN}/privacy-policy/`;

// Max width (pixels) of images that are uploaded through Post Image Post File, Share anything
export const MAX_IMAGE_WIDTH = 1580;
